<template>
  <v-app dark>
    <router-view @showSnack="showSnackMeth"></router-view>
    <v-snackbar
      v-model="snack"
      :timeout="10000"
      :color="snackColor"
      :auto-height="true"
    >
      {{ snackText }}
      <v-btn flat @click="snack = false">{{ $t('global.close') }}</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
//Default colors:
// primary: '#1976D2',
//   secondary: '#424242',
//   accent: '#82B1FF',
//   error: '#FF5252',
//   info: '#2196F3',
//   success: '#4CAF50',
//   warning: '#FFC107'
import store from '@/services/store'

export default {
  name: 'app',
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
  }),
  methods: {
    showSnackMeth(data) {
      this.snack = true
      this.snackColor = data.color
      this.snackText = data.text
    },
  },
  computed: {
    snackMessage: function() {
      return store.state.snackMessage
    },
  },
  watch: {
    snackMessage() {
      this.showSnackMeth(store.state.snackMessage)
    },
  },
}
</script>
